



































































































import Component from 'vue-class-component';
import ChatLogsCriteriaComponent from '@/containers/account/chat-logs/chat-logs-criteria.vue';
import { ISort } from '@/entities/sort.interface';
import { ISearchBody } from '@/entities/search-body.interface';
import { IPaging } from '@/entities/paging.interface';
import chatLogsApi from '@/api/chat-logs.api';
import { IChatLogListModel } from '@/entities/chat-logs/chat-log-list-model.interface';
import store from '@/store/store';
import * as types from '@/store/types';
import { AccountRole } from '@/entities/accounts/account-role.enum';
import { MasterPageCriteria } from '@/components/base/master/master-page-criteria';

@Component({
    components: {
        'chat-logs-criteria': ChatLogsCriteriaComponent
    }
})
export default class ChatLogsMaster extends MasterPageCriteria {
    public items: IChatLogListModel[] = [];

    protected defaultSort: ISort = {
        field: 'officeName',
        asc: true
    };

    get isAgent() {
        const role: AccountRole = store.getters[types.AUTH_GET_ROLE];
        return role === AccountRole.Agent;
    }

    public list(body: ISearchBody): Promise<IPaging<IChatLogListModel>> {
        return chatLogsApi.list(body);
    }
}
